export default "__VITE_PUBLIC_ASSET__ccb94bed__"